

























import Vue from 'vue';
import { IBlogEntry } from '@/common/interfaces/frontpage.interface';
import { IIcons } from '@/common/interfaces/index.interface';
import TIcons from '@/types/TIcons';

interface IBlogEntryMobileComponent {
  icons: IIcons;
}

export default Vue.extend({
  name: `BlogEntryMobile`,
  data(): IBlogEntryMobileComponent {
    return {
      icons: TIcons,
    };
  },
  props: {
    blogEntry: {
      required: true,
      type: Object as () => IBlogEntry,
    },
  },
});
